export default __webpack_public_path__ + "static/media/tap.877082cd.png";